import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const LoginNoticeBox = ({ text }) => (
  <p className="mt-3 whitespace-pre-line rounded-md border-2 border-[#E60000] bg-[#FFF1F1] px-4 py-3 text-sm font-bold leading-relaxed text-[#B00000]" role="alert" data-testid="login-intro-note">{text}</p>
);

export const LoginNotice = () => {
  const [n, setN] = useState(null);
  useEffect(() => {
    api.get("/site/login-notice").then((r) => setN(r.data)).catch(() => setN(null));
  }, []);
  return n?.enabled && n.text ? <LoginNoticeBox text={n.text} /> : null;
};
